import { render, staticRenderFns } from "./ItemViewTemplate.vue?vue&type=template&id=06c478a4&scoped=true&"
import script from "./ItemViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ItemViewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ItemViewTemplate.vue?vue&type=style&index=0&id=06c478a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c478a4",
  null
  
)

export default component.exports